import { useEffect, useRef } from "react";

export const useScrollParentToTop = <
  T extends HTMLElement = HTMLDivElement
>() => {
  const rootRef = useRef<T>(null);

  useEffect(() => {
    let parent = rootRef.current?.parentElement;
    while (parent) {
      const { overflowY } = window.getComputedStyle(parent);
      if (overflowY === "auto" || overflowY === "scroll") {
        parent.scrollTop = 0;
        break;
      }
      parent = parent.parentElement;
    }
  }, []);

  return rootRef;
};
